import React from 'react';
import * as StyledApartmentBox from './apartmentBox.styles';
import Images from './images';
import { formatCurrency } from '../../helpers/formatting/formatting';
import { getType } from '../../helpers/linkResolver/linkResolver';

const ApartmentBox = ({
	apartment
}) => {
	const type = getType(window.location.pathname)
	let prefix = ''
	if (type === 'grindavik') {
		prefix = '/' + type
	}
	
	return (
		<StyledApartmentBox.Wrapper to={`${prefix}/ibud/${apartment.Id}`}>
			<StyledApartmentBox.ImageWrapper>
				<Images images={apartment.Images} />
				<StyledApartmentBox.Info>
					<StyledApartmentBox.InfoValue>
						{`${apartment.Rooms} herbergja`}
					</StyledApartmentBox.InfoValue>
					<StyledApartmentBox.InfoSep />
					<StyledApartmentBox.InfoValue>
						{`${apartment.SquareMeters} fm`}
					</StyledApartmentBox.InfoValue>
					<StyledApartmentBox.InfoSep />
					<StyledApartmentBox.InfoValue>
						{apartment.Type}
					</StyledApartmentBox.InfoValue>
				</StyledApartmentBox.Info>
			</StyledApartmentBox.ImageWrapper>
			<StyledApartmentBox.Zip>
				{apartment.Zip}
			</StyledApartmentBox.Zip>
			<StyledApartmentBox.NameWrapper>
				<StyledApartmentBox.Name>{apartment.Address}</StyledApartmentBox.Name>
				<StyledApartmentBox.RentWrapper>
					<StyledApartmentBox.Rent>{formatCurrency(apartment.Rent)}</StyledApartmentBox.Rent>
					<StyledApartmentBox.RentSep>/</StyledApartmentBox.RentSep>
					<div>mán.</div>
				</StyledApartmentBox.RentWrapper>
			</StyledApartmentBox.NameWrapper>
		</StyledApartmentBox.Wrapper>
	);
};

export default ApartmentBox;
